/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Numbers_LanguagesInputs */

const en_about_numbers_languages = /** @type {(inputs: About_Numbers_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 EU Languages`)
};

const de_about_numbers_languages = /** @type {(inputs: About_Numbers_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 EU-Sprachen`)
};

const fr_about_numbers_languages = /** @type {(inputs: About_Numbers_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 EU Languages`)
};

const es_about_numbers_languages = /** @type {(inputs: About_Numbers_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 EU Languages`)
};

const it_about_numbers_languages = /** @type {(inputs: About_Numbers_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 EU Languages`)
};

const nl_about_numbers_languages = /** @type {(inputs: About_Numbers_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 EU Languages`)
};

const pl_about_numbers_languages = /** @type {(inputs: About_Numbers_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 EU Languages`)
};

const fi_about_numbers_languages = /** @type {(inputs: About_Numbers_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 EU Languages`)
};

const da_about_numbers_languages = /** @type {(inputs: About_Numbers_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 EU Languages`)
};

const sv_about_numbers_languages = /** @type {(inputs: About_Numbers_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 EU Languages`)
};

/**
* | output |
* | --- |
* | "10 EU Languages" |
*
* @param {About_Numbers_LanguagesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_numbers_languages = /** @type {((inputs?: About_Numbers_LanguagesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Numbers_LanguagesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_numbers_languages(inputs)
	if (locale === "fr") return fr_about_numbers_languages(inputs)
	if (locale === "es") return es_about_numbers_languages(inputs)
	if (locale === "it") return it_about_numbers_languages(inputs)
	if (locale === "nl") return nl_about_numbers_languages(inputs)
	if (locale === "pl") return pl_about_numbers_languages(inputs)
	if (locale === "fi") return fi_about_numbers_languages(inputs)
	if (locale === "da") return da_about_numbers_languages(inputs)
	if (locale === "sv") return sv_about_numbers_languages(inputs)
	return en_about_numbers_languages(inputs)
});